import styled from 'styled-components';
const ScrollablePanel = styled.div`
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-track {
    background: #130828;
    border-radius: 3px;
  }
  ::-webkit-scrollbar-thumb {
    background: #7332c6;
    border-radius: 3px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #611dbb;
  }
`;
export default ScrollablePanel;